import { useState } from "react";
import { siteNav, utilityBar, tickerItems } from "@/mocks/home";

export default function SiteHeader() {
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50">
      <div className="hidden md:flex items-center justify-between bg-foreground-950 px-6 py-2 text-xs text-background-100">
        <span className="flex items-center gap-2">
          <i className="ri-calendar-line"></i>
          {utilityBar.date}
        </span>
        <span className="flex items-center gap-5">
          <span className="flex items-center gap-1.5 text-accent-400">
            <span className="w-1.5 h-1.5 rounded-full bg-accent-400 animate-pulse"></span>
            {utilityBar.status}
          </span>
          <span className="text-background-400">{utilityBar.note}</span>
        </span>
      </div>

      <div className="border-b border-background-200 bg-background-50/90 backdrop-blur">
        <div className="flex items-center justify-between px-4 md:px-6 h-16">
          <a href="#cover" className="flex items-center gap-2.5 cursor-pointer">
            <span className="w-9 h-9 rounded-md bg-primary-500 text-background-50 flex items-center justify-center">
              <i className="ri-newspaper-line text-lg"></i>
            </span>
            <h1 className="font-heading text-xl font-bold tracking-tight whitespace-nowrap">
              黑料网曝
            </h1>
          </a>

          <nav className="hidden md:flex items-center gap-1">
            {siteNav.map((item) => (
              <a
                key={item.label}
                href={item.href}
                className="px-3 py-2 text-sm text-foreground-700 rounded-md transition-colors hover:text-primary-600 hover:bg-primary-50 whitespace-nowrap cursor-pointer"
              >
                {item.label}
              </a>
            ))}
          </nav>

          <div className="hidden md:flex items-center gap-3">
            <a
              href="#tips"
              className="flex items-center gap-1.5 rounded-md bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-send-plane-line"></i>
              我要爆料
            </a>
          </div>

          <button
            type="button"
            aria-label="打开菜单"
            onClick={() => setMobileOpen((prev) => !prev)}
            className="md:hidden w-9 h-9 flex items-center justify-center rounded-md border border-background-200 text-foreground-800 cursor-pointer"
          >
            <i className={mobileOpen ? "ri-close-line text-lg" : "ri-menu-line text-lg"}></i>
          </button>
        </div>

        {mobileOpen && (
          <div className="md:hidden border-t border-background-200 bg-background-50 px-4 py-3">
            <nav className="flex flex-col">
              {siteNav.map((item) => (
                <a
                  key={item.label}
                  href={item.href}
                  onClick={() => setMobileOpen(false)}
                  className="py-2.5 text-sm text-foreground-700 border-b border-background-100 last:border-0 cursor-pointer"
                >
                  {item.label}
                </a>
              ))}
            </nav>
            <a
              href="#tips"
              onClick={() => setMobileOpen(false)}
              className="mt-3 flex items-center justify-center gap-1.5 rounded-md bg-primary-500 px-4 py-2.5 text-sm font-medium text-background-50 cursor-pointer"
            >
              <i className="ri-send-plane-line"></i>
              我要爆料
            </a>
          </div>
        )}
      </div>

      <div className="flex items-stretch bg-primary-500 text-background-50">
        <div className="flex items-center gap-1.5 bg-primary-600 px-3 md:px-4 py-2 text-xs font-bold whitespace-nowrap">
          <i className="ri-flashlight-fill"></i>
          实时更新
        </div>
        <div className="relative flex-1 overflow-hidden">
          <div className="hlwp-ticker-track py-2">
            {[...tickerItems, ...tickerItems].map((text, index) => (
              <span
                key={`${text}-${index}`}
                className="inline-flex items-center gap-2 px-5 text-xs md:text-sm text-background-50"
              >
                <span className="w-1 h-1 rounded-full bg-accent-300"></span>
                {text}
              </span>
            ))}
          </div>
        </div>
      </div>
    </header>
  );
}